import Link from '../links/RouterLink'

export default (props) => {
    const {slug, thumb, title} = props
    return (
        <div className="item carousel-slide" key={slug}>
            <Link route="model" params={{slug}}>
                <img src={thumb}/>
                <strong className="thumb-title">{title}</strong>
            </Link>
        </div>
    )
}



// WEBPACK FOOTER //
// components/slides/Model.js